import _ from 'lodash';
import * as helpers from 'services/helpers';

export const reqTransform = {
  fetchDiscoveryBuyersSellers(params = {}) {
    const reqParams = {
      ...params,
    };
    return reqParams;
  },
  connectProfile(resData) {
    let data = {
      ...resData,
    };

    return data;
  },
};

// Natural key for a discovery row. ro_DiscoverBuyerSellers rolls its result up with
//   GROUP BY Person_Company_Affiliate_Id, Person_Company_Affiliate_Enum, Company_Id,
//            Commodity_Form_Code, Is_Market, Is_Wholesale, Commodity_Id
// so those columns are what make a row unique - mirror them here. Commodity_Id is only
// populated when the caller filters by commodity (BFC-8857); it is null otherwise and
// simply drops out of the key. `sort_by` is only the ROW_NUMBER() ranking, so it must
// never be the identity.
const buyerSellerKey = (row) => {
  const parts = [
    _.get(row, 'person_company_affiliate_id') || 0,
    _.get(row, 'person_company_affiliate_enum') || 0,
    _.get(row, 'buy_sell_company_id') || 0,
    _.get(row, 'buy_sell_person_id') || 0,
    _.get(row, 'commodity_form_code') || '',
    _.get(row, 'commodity_id') || 0,
    _.get(row, 'is_market') ? 1 : 0,
    _.get(row, 'is_wholesale') ? 1 : 0,
  ];
  return `bs-${parts.join('-')}`;
};

export const resTransform = {
  fetchDiscoveryBuyersSellers(resData) {
    const seen = {};
    const data = {};

    (resData || []).forEach((details, index) => {
      const baseId = buyerSellerKey(details);
      const occurrence = seen[baseId] || 0;
      seen[baseId] = occurrence + 1;
      // Two rows that genuinely share every identifying field still have to survive as
      // two cards, so disambiguate instead of letting one silently overwrite the other.
      const id = occurrence === 0 ? baseId : `${baseId}#${occurrence}`;
      data[id] = resTransform.fetchDiscoveryBuyersSellersDetails(details, id, index);
    });

    return data;
  },
  fetchDiscoveryBuyersSellersDetails(resData, id, index) {
    let res = {
      ...resData,
      id: id !== undefined ? id : buyerSellerKey(resData),
      // Keep the API ordering available even when several rows share a rank.
      sort_index: index,
    };
    return res;
  },
  connectProfile(resData) {
    let data = {
      ...resData,
    };

    return data;
  },
};
